// Helpers for the Reports listing's handling of lactate reports whose client
// is NOT in the directory cache (manually-entered / "new" clients).

/**
 * A manually-entered client has no directory record, so their reports cannot be
 * location/coach-scoped like normal reports. Per product rule, such reports are
 * visible to admins, managers, and anyone holding the lactate report-generation
 * permission — and hidden from everyone else.
 */
export function canViewManualLactateReport(
  userRole: string | null | undefined,
  hasLactateFeature: boolean
): boolean {
  return userRole === 'ADMIN' || userRole === 'MANAGER' || hasLactateFeature;
}

/**
 * Resolve a report row's display name. Prefer the name stored on the report
 * pointer itself (self-describing — written at generation time), then the
 * directory cache, else a placeholder that an on-read fallback may overwrite.
 */
export function resolveReportClientName(
  pointerName?: string,
  directoryName?: string
): string {
  const fromPointer = pointerName?.trim();
  if (fromPointer) return fromPointer;
  const fromDirectory = directoryName?.trim();
  if (fromDirectory) return fromDirectory;
  return 'Unknown Client';
}
